import {IMaterialTooltipPlacement, React, classNames, withStyles, StyledProps, CentricTheme, Tooltip2} from '@api'
import {IconButton, Tooltip} from '@material-ui/core'
import {nav, site} from '@stores'
import {observer} from 'mobx-react'
import {Icon, IconName, PopoverPosition} from '@blueprintjs/core'
import {ReactElement} from 'react'
import * as css from './PrimaryIconButton.css'

export interface PrimaryIconButtonProps extends React.AnchorHTMLAttributes<HTMLElement> {
  /** Boolean indicating whether the button should render as disabled */
  disabled?: boolean
  /** Function to be called on Button Click */
  onClick?: (e) => void
  /** React component of an icon */
  icon?: ReactElement<any> | IconName,
  value?: string
  variant?: string
  loading?: boolean
  active?: boolean
  disableRipple?: boolean
  disableTouchRipple?: boolean
  wrapperClassName?: string
  /* Is this one active of a group? */
  grouped?: boolean
  tooltip?: React.ReactNode
  tooltipStyle?: 'native' | 'mui' | 'blueprint'
  tooltipPosition?: IMaterialTooltipPlacement //PopoverPosition
  tooltipClassName?: string
  text?: React.ReactNode
  showOnHover?: boolean

  'data-location'?: string
}

@observer
export class PrimaryIconButton extends React.Component<PrimaryIconButtonProps> {
  static defaultProps = {
    disabled: false,
    tooltipStyle: 'native'
  }

  render() {
    const {onDoubleClick, props: {className, showOnHover, tooltipStyle, 'data-location': dl, icon, loading, wrapperClassName, children, active, onTouchEnd, disabled, tooltipPosition, tooltipClassName, grouped, text, type, tooltip, ...otherProps}} = this,
      stringTooltip = _.isString(tooltip)
    const r = (
      <span data-type='IconButtonWrapper' title={stringTooltip && tooltipStyle == 'native' ? tooltip : undefined}
            data-show-on-hover={showOnHover ? true : undefined} data-location={dl}
            className={classNames((stringTooltip || !tooltip) && wrapperClassName, css.wrapper)} aria-disabled={disabled} data-grouped={grouped} onDoubleClick={onDoubleClick}>
        <IconButton
          classes={{root: classNames(css.root, className), label: classNames({skeleton: loading})}}
          className={classNames(css.root, className)}
          data-type='IconButton'
          data-active={active}
          aria-disabled={disabled}
          disabled={disabled}
          tabIndex={0}
          {...otherProps}
          onPointerDown={otherProps.onClick ? this.onClick : undefined}
          onClick={undefined}
          //onClick={site.touchDevice || disabled ? undefined : this.onClick}
          onTouchEnd={site.touchDevice && !disabled ? this.onTouchEnd : undefined}
          color='primary'>
          {_.isString(icon) ? <Icon icon={icon as any}/> : icon || children}
        </IconButton>
        {text}
      </span>
    )

    return !tooltip || (stringTooltip && tooltipStyle === 'native') ? r
                    : tooltipStyle === 'blueprint' ?
                      <Tooltip2 content={tooltip as any ?? ''}
                               position={tooltipPosition as any}
                               className={classNames(wrapperClassName, tooltipClassName)}>{r}</Tooltip2>
                      : <Tooltip title={tooltip as any ?? ''}
                                    placement={tooltipPosition}
                                    className={classNames(wrapperClassName, tooltipClassName)}>{r}</Tooltip>
  }

  onDoubleClick = (e: React.MouseEvent<HTMLElement>) => {
    e.preventDefault()
    e.stopPropagation()
  }

  onClick = (e: React.MouseEvent<HTMLElement>) => {
    const {onClick, href, target, 'aria-disabled': ariaDisabled} = this.props
    if (!ariaDisabled) {
      onClick && onClick(e)
      if (href && target != '_blank') {
        e.preventDefault()
      }
    }
  }

  onTouchEnd = (e: React.TouchEvent<HTMLElement>) => {
    const {onClick, onTouchEnd, href, 'aria-disabled': ariaDisabled, disabled} = this.props
    if (!ariaDisabled && !disabled) {
      // NOTE: Calling both onTouch and onClick from props in case of touch devices,
      // verify if all cases where onTouchEnd is passed in props are working fine
      if (onTouchEnd) {
        onTouchEnd(e)
      }

      if (onClick) {
        onClick(e)
      }

      if (href) {
        e.preventDefault()
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/PrimaryIconButton.tsx